import { styled, Box, Button, Theme, Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BADGE_BACKGROUND,
  DARK_BUTTON_HOVER,
  DARK_SECONDARY_BUTTONBACKGROUND,
  DARK_TEXT,
  ERROR_BADGE_BACKGROUND,
  LIGHT_BADGE_BACKGROUND,
  LIGHT_BUTTON_BACKGROUND,
  OFFWHITE_BUTTON_BACKGROUND,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BACKGROUND,
} = COLORS;

const $gutter = 30;

export const MainCont = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 110px)',
}));

export const MenuButton = styled(Button)<Theme, { active: Boolean }>(({ theme, active }) => ({
  background:
    active && (theme.palette.type === 'dark' || theme.palette.type === 'light')
      ? PRIMARY_BUTTON_BACKGROUND
      : theme.palette.type === 'dark'
        ? DARK_SECONDARY_BUTTONBACKGROUND
        : OFFWHITE_BUTTON_BACKGROUND,
  color: active ? PLAIN_TEXT : theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  marginRight: 10,
  marginBottom: 10,
  borderRadius: 8,
  '&:hover': {
    background:
      active && (theme.palette.type === 'dark' || theme.palette.type === 'light')
        ? PRIMARY_BUTTON_BACKGROUND
        : theme.palette.type === 'dark'
          ? DARK_BUTTON_HOVER
          : PRIMARY_BUTTON_BACKGROUND,
    color: theme.palette.type === 'light' ? LIGHT_BUTTON_BACKGROUND : LIGHT_BUTTON_BACKGROUND,
  },
  [theme.breakpoints.down(960)]: {
    justifyContent: 'space-between',
    width: '100%',
    marginRight: 0,
    minWidth: 250,
  },
  padding: '7px 20px',
}));

export const Badge = styled(Box)<Theme, { disabled: boolean }>(({ theme, disabled }) => ({
  background: disabled
    ? theme.palette.type === 'dark'
      ? DARK_BADGE_BACKGROUND
      : LIGHT_BADGE_BACKGROUND
    : ERROR_BADGE_BACKGROUND,
  width: 30,
  height: 30,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 20,
  color: disabled ? (theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT) : PLAIN_TEXT,
}));

export const AuditionItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 25%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter * 3}px)`,

  [theme.breakpoints.down(1850)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const MobileMenuCont = styled(Accordion)(({ theme }) => ({
  background: 'transparent',
  width: '100%',
  position: 'relative',
  transition: '300ms',
  boxShadow: theme.palette.type === 'dark' ? '' : 'none',

  '& .Mui-expanded': {
    // paddingTop: 0,
  },

  '& .MuiAccordionSummary-content': {
    justifyContent: 'space-between',
    margin: 0,
  },
  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 'unset',
  },
}));

export const HeaderCont = styled(AccordionSummary)(() => ({
  padding: 0,
  display: 'flex',
  marginBottom: 10,
}));

export const Body = styled(AccordionDetails)(() => ({
  padding: 0,
}));
